import React,{useState} from "react";
import Tooltip from "@mui/material/Tooltip";
import { Zoom } from "@mui/material";
import { normalizeQuestion } from "../../../utils/questionNormalizer.js";
import DeleteQuestionModal from  "../../modals/DeleteQuestionModal.jsx";

function TrueOrFalseQuestionsRenderer({
  handleTrueOrFalseQuestionsEdit,
  handleTrueOrFalseQuestionDelete,
  handleTrueOrFalseQuestionChange,
  question,
  index,
}) {

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const normalizedQuestion = normalizeQuestion(question, "truefalse");
     // Handler for opening delete modal
  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

    // Handler for confirming delete
  const handleConfirmDelete = () => {
    handleTrueOrFalseQuestionDelete(normalizedQuestion.index);
  };
  return (
    <>
      {/* {trueFalseQuestions.map((trueFalseQuestion, index) => ( */}
      <div
        key={index}
        className="mb-4  border-slate-100 hover:border-[#f4833d] border-2 hover:border-dotted rounded question-answer-container p-4"
      >
        {/* Question goes here */}
        <div className="flex place-content-between">
          <div className="flex">
            <span>{index + 1}.&nbsp; </span>{" "}
            {question.editing ? (

              <div
                contentEditable="true"
                id={`question-${normalizedQuestion.index}`}
                className="wh-question-editable "
                onBlur={(e) => {
                  handleTrueOrFalseQuestionChange(
                    question.index,
                    e.target.textContent
                  );
                  handleTrueOrFalseQuestionsEdit(normalizedQuestion.index);
                }}
                dangerouslySetInnerHTML={{
                  __html: normalizedQuestion.question,
                }}
              />
            ) : (
              <span
                onClick={() => handleTrueOrFalseQuestionsEdit(normalizedQuestion.index)}
                className="cursor-pointer"
                dangerouslySetInnerHTML={{
                  __html: normalizedQuestion.question,
                }}
              />
            )}
          </div>


          <div className="flex edit-delete-icons">
            {/* Edit Icon */}
            <Tooltip
              title="Edit"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <button
                onClick={() => handleTrueOrFalseQuestionsEdit(normalizedQuestion.index)}
                className="text-indigo-500 mr-2"
              >
                <i className="fa-solid fa-pen-to-square"></i>{" "}
              </button>
            </Tooltip>

            {/* Delete Icon */}
            <Tooltip
              title="Delete"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <button
                onClick={handleDeleteClick}
                className="text-red-500"
              >
                <i className="fa-solid fa-trash"></i>{" "}
              </button>
            </Tooltip>
          </div>
        </div>

        {/* True or False Option */}
        <div className=" p-2 rounded ">
          <p
            className={`w-2/3 p-2 mb-1 rounded ${
              "True" === normalizedQuestion.answer ? "bg-[#c0f0e2]" : "bg-[#fdecf6]"
            }`}
          >
            True {normalizedQuestion.true_option}
          </p>
          <p
            className={`w-2/3 p-2 mb-1 rounded ${
              "False" === normalizedQuestion.answer ? "bg-[#c0f0e2]" : "bg-[#fdecf6]"
            }`}
          >
            False {normalizedQuestion.false_option}
          </p>
        </div>

        {/* Correct Answer */}
        <p>
          <strong>Answer:</strong> {normalizedQuestion.answer === 'True' ? 'True' : 'False'}
        </p>
      </div>
      <DeleteQuestionModal
          open={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirmDelete={handleConfirmDelete}
          questionNumber={index + 1}
        />
    </>
  );
}

export default TrueOrFalseQuestionsRenderer;
